import { FieldState,FieldStateKey,PermissionKey, PermissionState } from '@/common/constants';
import { useAuthStore } from '@/modules/user/stores';

const useGetHiddenLevelAccess = (permissionKey?: PermissionKey, fieldStateKey?: FieldStateKey) => {
  const { overridablePropertiesPermissions, overridablePropertiesFieldState } = useAuthStore();

  if (!overridablePropertiesPermissions) return {};

  const permissionState = permissionKey ? overridablePropertiesPermissions?.[permissionKey] : PermissionState.EDIT;
  let fieldState = FieldState.MODIFIABLE;

  if (fieldStateKey && overridablePropertiesFieldState && overridablePropertiesFieldState[fieldStateKey]) {
    fieldState = overridablePropertiesFieldState[fieldStateKey];
  }

  if (permissionState === PermissionState.HIDE || fieldState === FieldState.HIDDEN) {
    return true;
  }

 

  return false;
};

export default useGetHiddenLevelAccess;
